import { predict as bool } from './bool'
import { predict as date } from './date'
import { predict as number } from './number'
import options from './optionsHistory'

export default function createPredict(history = []) {
	const engines = [bool, date, number, options(history)]

	return (string = '') => {
		for (let result, i = 0; i < engines.length; i++) {
			result = engines[i](string)

			if (result.length) {
				return result
			}
		}

		return []
	}
}



// WEBPACK FOOTER //
// ./src/services/prediction/options.js